import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import styles from './style.module.css';
import { CSSTransition } from 'react-transition-group';
import HealthHeader from '../../../../Components/HealthHeader';
import Profile from './Profile';
import HistoryCard from './HistoryCard';
import DetailsCard from './DetailsCard';
import LeftIcon from './leftIcon.svg';
import DetailsCardTreatment from './DetailsCardTreatment';
import NovoTratamentoModal from './NovoTratamentoModal';
import BotHistoryCard from './BotHistoryCard';
import { usePatient } from '../../../../Contexts/PatientContext';
import { message } from 'antd';
import { 
  createTreatment, 
  linkMedicationToTreatment 
} from '../../../../services/kollectaHealthCore';

const DetalhePacienteDor = () => {
  const { id } = useParams();
  const { patientData, updatePatient } = usePatient();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dataFetched, setDataFetched] = useState(false);
  const [showNovoTratamentoModal, setShowNovoTratamentoModal] = useState(false);
  const [savingTreatment, setSavingTreatment] = useState(false);
  const [treatmentKey, setTreatmentKey] = useState(0);
  
  useEffect(() => {
    console.log('useEffect DetalhePacienteDor', id, patientData);
    
    if (dataFetched) return;
    
    const fetchPaciente = async () => {
      try {
        // setLoading(true);
        // const data = await getPacienteDorById(id);
        // updatePatient(data);
        // setDataFetched(true);
      } catch (err) {
        setError(err);
        message.error('Erro ao carregar dados do paciente');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchPaciente();
    }
  }, []);

  const handleSaveTratamento = async (medicationsList) => {
    try {
      setSavingTreatment(true);
      
      // Se não houver medicamentos na lista, não faz nada
      if (!medicationsList || medicationsList.length === 0) {
        message.warning('Nenhum medicamento foi adicionado ao tratamento.');
        setShowNovoTratamentoModal(false);
        return;
      }

      console.log('Iniciando vinculação de medicamentos:', medicationsList);

      // Pega o ID do último tratamento
      const lastTreatment = patientData.treatments[patientData.treatments.length - 1];
      const treatmentMedications = [];

      // Vincula cada medicamento ao tratamento
      for (const med of medicationsList) {
        console.log('Processando medicamento para vinculação:', med);
        
        const medicationData = {
          medication: {
            connect: {
              id: med.medication
            }
          },
          observations: med.observations || "",
          frequency: med.interval,
          dosage: med.dosage || "-"
        };
        
        console.log('Dados para vinculação:', medicationData);
        
        try {
          const linkResponse = await linkMedicationToTreatment(lastTreatment.id, medicationData);
          console.log('Resposta da vinculação:', linkResponse);
          
          if (linkResponse.data) {
            treatmentMedications.push(linkResponse.data);
          }
        } catch (linkError) {
          console.error('Erro ao vincular medicamento:', linkError);
          message.error(`Erro ao vincular medicamento ${med.medicationName}. Por favor, tente novamente.`);
        }
      }

      // Atualiza o contexto do paciente com os medicamentos vinculados
      const updatedTreatment = {
        ...lastTreatment,
        treatmentMedications: [
          ...(lastTreatment.treatmentMedications || []),
          ...treatmentMedications
        ]
      };

      // Atualiza a lista de tratamentos do paciente
      const updatedTreatments = [...patientData.treatments];
      updatedTreatments[updatedTreatments.length - 1] = updatedTreatment;

      updatePatient({
        ...patientData,
        treatments: updatedTreatments
      });

      message.success('Medicamentos vinculados com sucesso!');
      setShowNovoTratamentoModal(false);
      
      // Força o refresh do componente de tratamentos
      setTreatmentKey(prev => prev + 1);

    } catch (error) {
      console.error('Erro ao vincular medicamentos:', error);
      message.error('Erro ao vincular medicamentos. Por favor, tente novamente.');
    } finally {
      setSavingTreatment(false);
    }
  };

  if (loading) {
    return <div>Carregando dados do paciente...</div>;
  }

  if (error) {
    return <div>Erro ao carregar dados do paciente: {error.message}</div>;
  }

  return (
    <div className={styles.container}>
      <CSSTransition
        in={true}
        classNames="anim"
        timeout={500}
        appear={true}
        unmountOnExit={false}
      >
        <div>
          <section>
            <div className={styles.top}>
              <HealthHeader title="Perfil de Pacientes" />
            </div>     

            <div className={styles.topCardsContainerTop}>
              <Profile onAddTreatment={() => setShowNovoTratamentoModal(true)} />
              <HistoryCard />            
            </div>
          </section>

          <section className={styles.cardContainer}>
            <div className={styles.subtitle}>
              <h3> Características Clínicas  </h3>
              <img src={LeftIcon} alt="Kollecta Health"/>
            </div>
            <DetailsCard />
          </section>

          <section className={styles.cardContainer}>
            <div className={styles.subtitle}>
              <h3> Terapia medicamentosa  </h3>
              <img src={LeftIcon} alt="Kollecta Health"/>
            </div>
            <DetailsCardTreatment key={treatmentKey} type="medications" />
          </section>

          <section className={styles.cardContainer}>
            <div className={styles.subtitle}>
              <h3> Terapia não medicamentosa  </h3>
              <img src={LeftIcon} alt="Kollecta Health"/>
            </div>
            <DetailsCardTreatment />
          </section>

          <section className={styles.cardContainer}>
            <div className={styles.subtitle}>
              <h3> Histórico de Mensagens  </h3>
              <img src={LeftIcon} alt="Kollecta Health"/>
            </div>
            {console.log('personalNumber para BotHistoryCard:', patientData?.customer?.personalNumber)}
            <BotHistoryCard personalNumber={patientData?.customer?.personalNumber} />
          </section>

          <NovoTratamentoModal 
            visible={showNovoTratamentoModal}
            onClose={() => setShowNovoTratamentoModal(false)}
            onSave={handleSaveTratamento}
          />
        </div>
      </CSSTransition>
    </div>
  );
};

export default DetalhePacienteDor;
